import { SlidersHorizontal } from "lucide-react";
import { useEffect, useState } from "react";
import { mapProviderToDisplayName } from "../ProviderDropdown/utils";
import { ProviderWithLogoProps } from "./types";

const PROVIDER_ICON_SLUGS: Record<string, string> = {
  openai: "openai",
  anthropic: "anthropic",
  google: "google",
  "openai.azure": "azure",
  "anthropic.bedrock": "bedrock",
  together: "together",
  anyscale: "anyscale",
  huggingface: "huggingface",
  cohere: "cohere",
  gemini: "gemini",
  mistral: "mistral",
  fireworks: "fireworks",
  groq: "groq",
  llama: "llama",
  settings: "settings",
};

export const ProviderWithLogo = ({
  provider,
  hideName = false,
}: ProviderWithLogoProps) => {
  const [iconLoadError, setIconLoadError] = useState(false);
  const iconSlug = PROVIDER_ICON_SLUGS[provider || ""] || provider;

  useEffect(() => {
    setIconLoadError(false);
  }, [provider]);

  return (
    <div className="flex items-center">
      {iconLoadError ? (
        <SlidersHorizontal className="mr-2 h-4 w-4 transition-colors" />
      ) : (
        <img
          src={`https://unpkg.com/@lobehub/icons-static-svg@latest/icons/${iconSlug}.svg`}
          alt={`${provider} icon`}
          className="mr-2 h-4 w-4 transition-colors"
          onError={() => setIconLoadError(true)}
        />
      )}
      {!hideName && mapProviderToDisplayName(provider || "")}
    </div>
  );
};
